"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    standardModal: {
        title: 'Standards',
        standard: 'Standard',
        domain: 'Domain',
        cluster: 'Cluster',
        clusterstatement: 'Cluster',
        strand: 'Strand',
        knowledgeskill: 'Teks',
        relatedAssessments: 'Related Assessments',
        fetchingInformation: 'Fetching Information, please wait a second',
    },
};
